import { useState } from "react";

/* ✅ IMAGE IMPORTS (WORKING METHOD) */
import cardamomImg from "../assets/product/img11.webp";
import pepperImg from "../assets/product/pp1.webp";

export default function Products() {
  const WHATSAPP_NUMBER = "919944940620";

  const [cardamomSize, setCardamomSize] = useState("6mm");
  const [pepperType, setPepperType] = useState("Export");

  const openWhatsApp = (product, extra) => {
    const message = `Hello Kaali Global Import & Export,

I am interested in the following product:

Product: ${product}
Specification: ${extra}

Please share pricing, grades, and availability.`;

    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  const sizes = ["5mm", "6mm", "7mm", "7.5mm", "8mm"];

  return (
    <section
      id="products"
      className="py-24 bg-gradient-to-b from-[#f6f7f5] to-white"
    >
      {/* SECTION HEADER */}
      <div className="text-center mb-20 px-6">
        <p className="uppercase tracking-widest text-xs text-gray-500 mb-3">
          Products
        </p>
        <h2 className="text-4xl font-serif mb-4">
          Cardamom & Black Pepper
        </h2>

        <div className="w-20 h-[2px] bg-[#c9a24d] mx-auto mb-6" />

        <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
          Kaaliglobal supplies premium-quality Cardamom and Black Pepper,
          carefully sourced, graded, and prepared to meet domestic and
          international market requirements.
        </p>
      </div>

      {/* PRODUCTS GRID */}
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16">

        {/* GREEN CARDAMOM */}
        <div className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition duration-500">
          <div className="bg-[#f6f7f5] p-10">
            <img
              src={cardamomImg}
              alt="Green Cardamom"
              className="h-72 mx-auto group-hover:scale-105 transition duration-500"
            />
          </div>

          <div className="p-10 text-center">
            <h3 className="text-2xl font-serif mb-4">
              Green Cardamom
            </h3>

            <p className="text-gray-600 text-sm mb-6">
              Premium grade cardamom sourced directly from Indian farms.
            </p>

            {/* SIZE SELECTOR */}
            <div className="flex justify-center gap-3 mb-8 flex-wrap">
              {sizes.map((size) => (
                <button
                  key={size}
                  onClick={() => setCardamomSize(size)}
                  className={`px-4 py-1 text-sm rounded-full border transition
                    ${cardamomSize === size
                      ? "bg-[#0a7d4f] text-white border-[#0a7d4f]"
                      : "border-gray-300 text-gray-600 hover:border-[#0a7d4f]"
                    }`}
                >
                  {size}
                </button>
              ))}
            </div>

            <button
              onClick={() =>
                openWhatsApp("Green Cardamom", `Size: ${cardamomSize}`)
              }
              className="border border-[#0a7d4f] text-[#0a7d4f] px-10 py-3 rounded-full hover:bg-[#0a7d4f] hover:text-white transition"
            >
              Enquire Now
            </button>
          </div>
        </div>

        {/* BLACK PEPPER */}
        <div className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition duration-500">
          <div className="bg-[#f6f7f5] p-10">
            <img
              src={pepperImg}
              alt="Black Pepper"
              className="h-72 mx-auto group-hover:scale-105 transition duration-500"
            />
          </div>

          <div className="p-10 text-center">
            <h3 className="text-2xl font-serif mb-4">
              Black Pepper
            </h3>

            <p className="text-gray-600 text-sm mb-6">
              Strong aroma, bold flavor, export quality black pepper.
            </p>

            {/* EXPORT / DOMESTIC */}
            <div className="flex justify-center gap-3 mb-8">
              {["Export", "Domestic"].map((type) => (
                <button
                  key={type}
                  onClick={() => setPepperType(type)}
                  className={`px-5 py-1 text-sm rounded-full border transition
                    ${pepperType === type
                      ? "bg-[#0a7d4f] text-white border-[#0a7d4f]"
                      : "border-gray-300 text-gray-600 hover:border-[#0a7d4f]"
                    }`}
                >
                  {type}
                </button>
              ))}
            </div>

            <button
              onClick={() =>
                openWhatsApp("Black Pepper", `Supply Type: ${pepperType}`)
              }
              className="border border-[#0a7d4f] text-[#0a7d4f] px-10 py-3 rounded-full hover:bg-[#0a7d4f] hover:text-white transition"
            >
              Enquire Now
            </button>
          </div>
        </div>

      </div>
    </section>
  );
}
